import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../layouts/shared-service';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MdDialog, MdDialogRef, MdDialogConfig } from '@angular/material';
import { Router} from '@angular/router';
import { environment } from 'environments/environment.prod';
import { httpservice } from 'http/http';
import { isArray } from 'util';
const breadcrumb: any[] = [
  {
    title: 'Home'

  },
  {
    title: 'Event and Interruption'

  }
];

@Component({
  selector: 'page-event',
  templateUrl: './event.html',
  styleUrls: ['./event.scss']
})

export class PageEvent implements OnInit {
  pageTitle: string = environment.sysName;
  breadcrumb: any[] = breadcrumb;
  cksearch:boolean=false;
  form: FormGroup;
  rows = [];
  temp=[];
  key:any="";
  filteredEvent:any;
  eventCtrl:FormControl;
  user_selected = new FormControl();
  users = [];
  fileupload:string;fileupload_:string;
  data:any;
  arr_user=[];
  code:string;name:string;vender:string;ct:string;spec:string;
  loadingIndicator: boolean = true;
  selected:any;
  id:string;
  ckedit:boolean=false;
  //upload file
  imageSrc:any;
  imageSrc_:any;
  urlApi=environment.url+"/api/uploadToserver.php";
  urlApi_=environment.url+"/api/uploadToserverMachine.php";
  Name:string; 
  myFile:File; /* property of File type */
  myFile_:File;
  events=[];
  dialogRefWarning: MdDialogRef<WarningEventDialog>;
  dialogRef: MdDialogRef<eventDialog>;
  setId:any;
  sysPath:String=environment.sysPath;

  event_types = [
    { view: 'Man', value: '1' },
    { view: 'Machine', value: '2' },
    { view: 'Material', value: '3' },
    { view: 'Method', value: '4' },
    { view: 'NG-PD', value: '5' },
    { view: 'NG-PD-Hold', value: '6' },
    { view: 'NG-PD-Adjust', value: '7' },
    { view: 'NG-PD-Rework', value: '8' },
    { view: 'NG-FG', value: '9' },
    { view: 'NG-PT', value: '10' },
    { view: 'NG-RM', value: '11' }
  ];

  ts_type = new FormControl();
  ts_color = new FormControl();
  ts_font_color = new FormControl();
  ts_type_ng:String;
  ts_color_ng:String;
  ts_font_color_ng:String;

  colors = [];
  sysPathPrint:String=environment.sysPath+"/api/event-list-print.php";
  sysPathExport:String=environment.sysPath+"/api/event-list-export.php";
  constructor(private fb: FormBuilder,private httpservice:httpservice,private router: Router,public dialog: MdDialog,private _sharedService: SharedService ) {

  this.getEvent();
  this.getStartData();
  this.getEventColor();
this._sharedService.emitChange(this.pageTitle);
  }
  intervalGetData(){
    
    return setInterval(() => {
      if(this.setId.runCount>5){
      clearInterval(this.setId);
      }
      this.getStartData();
      console.log('------this.setId------',this.setId.runCount);
     }, 1000);

  }
  getStartData(){
    this.httpservice.fetchget('getJSON_event.php?',(data) => {
      this.rows = data;
      this.temp = data;
      this.loadingIndicator = false;
      console.log('------this.cksearch------',this.cksearch);
    });
  }
  getEventColor(){
    this.httpservice.fetchget('getJSON_event_color.php?',(data) => {
        this.colors = data;
      });
  }

  getEvent(){
    this.httpservice.fetchget('getJSON_event.php?',(data) => {
      this.events = data;
      console.log('------this.event------', this.events);
    });
    this.eventCtrl = new FormControl();
    this.filteredEvent = this.eventCtrl.valueChanges
    .startWith(null)
    .map(val => {
      if (isArray(val)) {
        this.key = val[0];
        //this.poCtrl.setValue(val[0]);
      } else {
        this.key = val;
        //this.poCtrl.setValue(val);
      }
      console.log('------val------',this.key);
         return val ? this.events.filter((s) => new RegExp(val.ts_name, 'gi').test(s)) : this.events;
    });
  }

  delete(id:string){
  let val = {id:id}
  this.httpservice.fetchpost('deleteEvent.php', val, (cb) => {});
  this.getStartData();
  }

  setedit(id:string){
    this.id = id;
    this.ckedit=true;
    this.httpservice.fetchget('getJSON_event.php?id='+id,(data) => {
      this.form.controls.ts_name.setValue(data[0].ts_name);
        this.ts_type_ng = data[0].ts_type;
        this.ts_font_color_ng = data[0].ts_font_color;
        this.ts_color_ng = data[0].ts_color;
      //this.form.controls.ts_color.setValue(data[0].ts_color);
      //this.form.controls.ts_font_color.setValue(data[0].ts_font_color);
      //this.form.controls.ts_type.setValue(data[0].ts_type_show);
    });
  }

  edit(){
    this.setId = this.intervalGetData();
    this.ckedit = false;
    this.data = {
      id:this.id,
      ts_name:this.form.controls.ts_name.value,
      ts_color:this.ts_color.value,
      ts_font_color:this.ts_font_color.value,
      ts_type:this.ts_type.value
    }
    // insert data
    this.httpservice.fetchpost('editDataEvent.php', this.data, (cb) => {});

    this.getStartData();
    this.cancelEdit();


  }

  cancelEdit(){
    this.ckedit = false;
    this.ts_type.reset();
    this.ts_color.reset();
    this.ts_font_color.reset();
    this.form.reset();
    this.ts_type.reset();
    this.ts_color.reset();
    this.ts_font_color.reset();
  }

save(){
  this.setId = this.intervalGetData();
  if (this.myFile != null) {
    this.fileupload = this.myFile.name;
  } else {
    this.fileupload = "";
  }

  this.data = {
    ts_name:this.form.controls.ts_name.value,
    ts_color:this.ts_color.value,
    ts_font_color:this.ts_font_color.value,
    ts_type:this.ts_type.value
  }
  // insert data
  this.httpservice.fetchpost('insertDataEvent.php', this.data, (cb) => {});
  this.getStartData();
  this.cancelEdit();
}

search(){
  //this.cksearch=true;
  clearInterval(this.setId);
  this.httpservice.fetchget('getJSON_event.php?key='+this.key,(data) => {
    this.rows = data;
    this.events = data;
    console.log('------this.setId------', this.events,this.setId);
  });
  this.eventCtrl.reset();
  this.key="";
  }

  ngOnInit() {
    this.form = this.fb.group({
      ts_name: [null, Validators.compose([Validators.required])]
    });

  }

    updateFilter(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.ts_name.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  updateFilter_(event) {
    const val = event.target.value;
    // filter our data
    const temp = this.temp.filter(function(d) {  
    return d.ts_type_show.toLowerCase().indexOf(val) !== -1 || !val;
    });
    // update the rows
    this.rows = temp;
  }

  openDeleteDialog(id:string) {

    let dialogRef = this.dialog.open(eventDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to delete this?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
          this.delete(id);
        console.log('---result---',result,id);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openEditDialog(){
    let dialogRef = this.dialog.open(eventDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.ts_type.value != null && this.form.controls.ts_name.value!=null && this.ts_color.value && this.ts_font_color.value !=""){
          this.edit();
        }else{
          this.warningDialog('Please fill in Event name, color, font color !');
        }
      
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }
  openDialog(){
    let dialogRef = this.dialog.open(eventDialog);
    let instance = dialogRef.componentInstance;
    instance.message = "Do you want to save?";
    instance.title = "Please confirm";
     dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;
      if(result==='1'){
        if(this.ts_type.value != null && this.form.controls.ts_name.value!=null && this.ts_color.value && this.ts_font_color.value !=""){
          this.save();
        }else{
            this.warningDialog('Please fill in Event name, color, font color !');
        }
        console.log('---result---',result);
       // alert('postString');
      }else{
        console.log('---result---',result);
       // alert('cancel');
      }
    });
  }

  warningDialog(message: string) {

    let dialogRef = this.dialog.open(WarningEventDialog);
    let instance = dialogRef.componentInstance;
    instance.message = message;
    instance.title = "Warning";

    dialogRef.afterClosed().subscribe(result => {
      //this.selectedOption = result;

      if (result === '1') {

        // alert('postString');
      } else {
        console.log('---result---', result);
        // alert('cancel');
      }

    });
  }
}
//dialog
@Component({
  selector: 'event-dialog',
  templateUrl: 'dialog.html',
})
export class eventDialog {
  title = '';
  message = '';
  constructor(public dialogRef: MdDialogRef<eventDialog>) {}
}

//warning
@Component({
  selector: 'warning-event-dialog',
  templateUrl: 'warning.html',
})
export class WarningEventDialog {
  title = '';
  message = '';
  constructor(public dialogRefWarning: MdDialogRef<WarningEventDialog>) { }
}



// WEBPACK FOOTER //
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/src/app/pages/event/event.ts